import ListSelect from '../ListSelect/ListSelect'
import { playerStatFieldNames } from '../../utils/DataUtils'
import { snakeToPascal } from '../../utils/StringUtils'
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
  Typography,
  Collapse
} from '@material-ui/core'
import './PlayerDetailsFilter.css'
import ToggleButton from '../ToggleButton/ToggleButton'
import { useState } from 'react'

const PlayerDetailsFilter = ({
  matchStats,
  selectedNumerator,
  selectedDenomintator,
  selectedSortMode,
  onNumeratorChange,
  onDenominatorChange,
  onSortChange
}) => {
  const [expanded, setExpanded] = useState(true)

  const statOptions = playerStatFieldNames(
    Array.from(matchStats.values())[0]
  ).map((playerStatName) => ({
    value: playerStatName,
    displayText: snakeToPascal(playerStatName)
  }))

  return (
    <Collapse in={expanded} collapsedHeight={80}>
      <div className="playerDetailsFilter">
        {expanded && (
          <div className="statSelector">
            <ListSelect
              options={statOptions}
              label="Numerator"
              selectedValue={selectedNumerator}
              onChange={(value) => onNumeratorChange(value)}
              hideAll
            />
            <div className="statDivider">
              <p>/</p>
            </div>
            <ListSelect
              options={[{ value: '', displayText: '-' }, ...statOptions]}
              label="Denominator"
              selectedValue={selectedDenomintator}
              onChange={(value) => onDenominatorChange(value)}
              hideAll
            />
          </div>
        )}
        <div className="playerFilterBottomRow">
          {expanded ? (
            <FormControl>
              <FormLabel>
                <Typography variant="caption" color="textSecondary">
                  Sort Mode
                </Typography>
              </FormLabel>
              <RadioGroup
                aria-label="Sort By"
                name="sortByOptions"
                value={selectedSortMode}
                onChange={(e) => onSortChange(e.target.value)}
                row
              >
                <FormControlLabel
                  value="playerName"
                  control={<Radio color="primary" />}
                  label="Player Name"
                />
                <FormControlLabel
                  value="statValue"
                  control={<Radio color="primary" />}
                  label="Stat Value"
                />
              </RadioGroup>
            </FormControl>
          ) : (
            <p>
              {selectedDenomintator
                ? `${snakeToPascal(selectedNumerator)}/${snakeToPascal(
                    selectedDenomintator
                  )}`
                : snakeToPascal(selectedNumerator)}
            </p>
          )}
          <div className="collapseButton">
            <ToggleButton
              toggled={expanded}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? '▲' : '▼'}
            </ToggleButton>
          </div>
        </div>
      </div>
    </Collapse>
  )
}

export default PlayerDetailsFilter
